export const API_BASE_URL =
// apps created with create-react-app to have environment variables flow through the build process, they must be prepended with REACT_APP_
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';
